module.exports = __webpack_public_path__ + "img/icon_biochem.a557c1e.svg";